import React from "react";
import { useState } from "react";
import { ApiSubscriptionPlan } from "src/api/types";
import useGet from "src/hooks/rest/useGet";
import SubscriptionGrid from "./SubscriptionGrid";
import SubscriptionPlan from "./SubscriptionPlan";
import SubscriptionPlanCustom from "./SubscriptionPlanCustom";
import SubscriptionPlanSelected from "./SubscriptionPlanSelected";
import SubscriptionIntervalSwitch from "src/components/subscription/SubscriptionIntervalSwitch";
import usePlans from "src/hooks/api/usePlans";

const SubscriptionPlans = () => {
	const { intervalEnabled } = usePlans();
	let [{ data: plans }, loading] = useGet("/auth/subscriptions/plans");
	const [selected, setSelected] = useState({} as ApiSubscriptionPlan);
	if (selected?.slug) {
		plans = plans.filter(
			(p: ApiSubscriptionPlan) => p.slug === selected.slug
		);
	}

	return (
		<>
			{intervalEnabled && (
				<div className="mt-8 mb-6">
					<SubscriptionIntervalSwitch />
				</div>
			)}
			<SubscriptionGrid columns={plans?.length || 3} {...{ selected }}>
				{!loading &&
					(plans || []).map(
						(plan: ApiSubscriptionPlan, index: number) => (
							<SubscriptionPlan
								key={plan.slug}
								onSelect={(plan) =>
									setSelected(plan as ApiSubscriptionPlan)
								}
								isRecommended={plan.is_most_common}
								isSelected={selected?.slug === plan.slug}
								{...{ plan }}
							/>
						)
					)}
				{selected?.slug && (
					<SubscriptionPlanSelected
						plan={selected}
						onCancel={() => setSelected({} as ApiSubscriptionPlan)}
					/>
				)}
			</SubscriptionGrid>
			{!selected?.slug && <SubscriptionPlanCustom />}
		</>
	);
};

export default SubscriptionPlans;
